import React from 'react'
import Link from 'redux-first-router-link'
import { useSelector } from 'react-redux'
import {
  SETTINGS_CANNEDREPLIES_PAGE,
  SETTINGS_RULES_PAGE,
  SETTINGS_FOLDERS_PAGE,
} from 'subapps/settings/types'
import { LANDING_PAGE as KB_LANDING_PAGE } from 'subapps/kb/pages'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser'
import {
  rules as RulesIcon,
  instantReplies as InstantRepliesIcon,
  folders as FoldersIcon,
  knowledge as KnowledgeBaseIcon,
} from 'assets/icons/groove/v2'
import {
  HIDE_CANNED_REPLY_ACTIONS_CALLOUT,
  HIDE_RULE_TRIGGERS_CALLOUT,
} from 'ducks/flags/flagNames'
import { selectFlag } from 'ducks/flags'
import ButtonWithMenu from '../ButtonWithMenu'

export const sectionPages = {
  cannedReplies: SETTINGS_CANNEDREPLIES_PAGE,
  rules: SETTINGS_RULES_PAGE,
  folders: SETTINGS_FOLDERS_PAGE,
  kb: KB_LANDING_PAGE,
}

const toSettingsCannedRepliesPage = {
  type: sectionPages.cannedReplies,
}

const toKbLandingPage = { type: sectionPages.kb }

const toSettingsRulesPage = {
  type: sectionPages.rules,
}

const toSettingsFoldersPage = {
  type: sectionPages.folders,
}

const activeColor = '#FBEFFF'

const Menu = ({ onClose }) => {
  const isManager = useSelector(selectCurrentUserIsAdminOrOwner)
  const shouldHideNewForCannedReply = useSelector(state =>
    selectFlag(state)(HIDE_CANNED_REPLY_ACTIONS_CALLOUT)
  )

  const shouldHideNewRule = useSelector(state =>
    selectFlag(state)(HIDE_RULE_TRIGGERS_CALLOUT)
  )

  return (
    <ButtonWithMenu.Menu>
      <ButtonWithMenu.Menu.Item
        icon={<InstantRepliesIcon className="md-icon" />}
        title={`${app.t('Canned_replies')} w/ actions`}
        copy="Save time using canned responses for common questions."
        as={Link}
        to={toSettingsCannedRepliesPage}
        onClick={onClose}
        activeColor={activeColor}
        isNew={shouldHideNewForCannedReply === false}
      />
      <ButtonWithMenu.Menu.Item
        icon={<KnowledgeBaseIcon className="md-icon" />}
        title="Knowledge Base"
        copy="A custom FAQ page designed to minimize inbound requests."
        as={Link}
        to={toKbLandingPage}
        onClick={onClose}
        activeColor={activeColor}
      />
      {isManager && (
        <ButtonWithMenu.Menu.Item
          icon={<RulesIcon className="md-icon" />}
          title="Rules"
          copy="Eliminate repetitive work using “if this, then that” logic."
          as={Link}
          to={toSettingsRulesPage}
          onClick={onClose}
          activeColor={activeColor}
          isNew={shouldHideNewRule === false}
        />
      )}
      {isManager && (
        <ButtonWithMenu.Menu.Item
          icon={<FoldersIcon className="md-icon" />}
          title={app.t('Folders')}
          copy="Create custom views based on your company needs."
          as={Link}
          to={toSettingsFoldersPage}
          onClick={onClose}
          activeColor={activeColor}
        />
      )}
    </ButtonWithMenu.Menu>
  )
}

export default Menu
